import Vue from 'vue';
import Config from '../configuration';

export default {
    namespaced: true,
    state: {},
    mutations: {

    },
    getters: {

    },
    actions: {
        getUser (context, payload)
        {
            return new Promise(function (resolve, reject)
            {
                Vue.axios.get(Config.GetUrl(Config.kritaApi) + 'user' , {
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        },
        selectCompany (context, id)
        {
            return new Promise(function (resolve, reject)
            {
                Vue.axios.put(Config.GetUrl(Config.kritaApi) + 'user/' + id , {},{
                }).then(function (response)
                {
                    if (response.data.HasError)
                    {
                        reject(new Error('no results'));
                    }
                    else
                    {
                        resolve(response.data.Data);
                    }
                }, () =>
                {
                    reject(new Error('no results'));
                });
            });
        }
    }
}
